import React from "react";
import { motion } from "framer-motion";
import "./CertificateNew.css";

export default function CertificateNew({ projectDetail }) {
  if (!projectDetail) return null;

  return (
    <section className="section-padding">
      <div className="mini-container">
        <div className="inner-flex inner-flex-medium">
          <div className="section-title">
            <h2>Certificates</h2>
          </div>

          <div
            className={`certificates-new-grid ${
              Number(projectDetail?.project_id) === 881 &&
              "certificates-new-grid-sarvam"
            }`}
          >
            <motion.div
              className="certificate-card"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <img src="/images/certificates/plan-pass.png" alt="" />
            </motion.div>

            <motion.div
              className="certificate-card"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
            >
              <img src="/images/certificates/rera-approved.png" alt="" />
            </motion.div>

            <motion.div
              className="certificate-card"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
            >
              <img src="/images/certificates/igbc.png" alt="" />
            </motion.div>

            {Number(projectDetail?.project_id) === 881 && (
              <motion.div
                className="certificate-card"
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.8, delay: 0.45, ease: "easeOut" }}
              >
                <img src="/images/certificates/bu-certified.png" alt="" />
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
